import type { CookieRepositoryStrategy } from './cookie.constants'

export const StorageStrategy = {
  LocalStorage: 'LocalStorage',
  SessionStorage: 'SessionStorage',
  Cookie: 'Cookie',
} as const

export type StorageStrategy = (typeof StorageStrategy)[keyof typeof StorageStrategy]

export type Config = (typeof CookieRepositoryStrategy)[keyof typeof CookieRepositoryStrategy]
